export default __webpack_public_path__ + "static/media/REFIN_affrescati_LP_CONF_CALCE-40X80.dd867252.jpg";